<template>
	<header class="page-header" :class="pageHeaderStyle + ` ` + pageHeaderBg + ` ` + pageHeaderSpacing">
		<!-- Knowledge base home header option-->
		<div :class="pageHeaderContainer" v-if="isSearchHeader">
			<div class="page-header-content pt-4">
				<div class="row align-items-center justify-content-between">
					<div class="col-auto mt-4">
						<h1 class="page-header-title">
							<div class="page-header-icon">
								<i data-feather="life-buoy"></i>
							</div>
							Base de connaissances
						</h1>
						<div class="page-header-subtitle"> Que cherchez-vous ? Notre base de connaissances est là pour vous aider.</div>
					</div>
				</div>
			</div>
		</div>
		<div :class="pageHeaderContainer" v-else>
			<div class="page-header-content pt-4">
				<div class="row align-items-center justify-content-between">
					<div class="col-auto mt-4">
						<h1 class="page-header-title">
							<div class="page-header-icon" v-if="pageIcon">
								<!-- <i :data-feather="pageIcon"/> -->
								<fa :icon="pageIcon" />
							</div>
							<div class="page-header-subtitle" v-if="instanceClass">
								<h1 class="page-header-title">
									{{ $t(instanceClass+ '.list') }}
								</h1>
							</div>
							<div class="page-header-subtitle" v-else>
								<h1 class="page-header-title">
									{{pageTitle}}
								</h1>
							</div>
						</h1>
						<div class="page-header-subtitle" v-if="instanceClass">
							{{ $t(instanceClass+ '.label') }}
						</div>
						<div class="page-header-subtitle" v-else>
							{{pageSubtitle}}
						</div>
					</div>
					<div class="col-auto" v-if="this.$store.getters.loggedIn">
						<fa icon="user" class="pr-1"/>
						<i>{{this.$store.getters.prsInfo.prsName}}</i>
						<!-- <i>{{this.$store.getters.username}}</i> -->
					</div>
				</div>
				<ol class="breadcrumb mb-0 mt-4" v-if="breadcrumbs">
					<li class="breadcrumb-item">
						<router-link :to="{ name: 'dashboard' }">{{ $t('header.dashboard') }}</router-link>
					</li>
					<li class="breadcrumb-item active">{{ pageTitle }}</li>
				</ol>
				<div class="page-header-search mt-4" v-if="search">
					<div class="input-group input-group-joined">
						<input class="form-control" type="text" placeholder="Search ..." aria-label="Search ..." autofocus="autofocus" />
						<div class="input-group-append">
							<span class="input-group-text">
								<i :data-feather="search"></i>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import { linkActivationMixin } from '@/mixins/linkActivationMixin'
export default {
	name: 'Header',
	mixins: [linkActivationMixin],
	props: {
		pageHeaderStyle: {
			type: String,
			default: 'page-header-dark'
		},
		pageHeaderBg: {
			type: String,
			default: 'bg-gradient-primary-to-secondary'
		},
		pageHeaderSpacing: {
			type: String,
			default: 'mb-4'
		},
		pageHeaderContainer: {
			type: String,
			default: 'container'
		},
		pageIcon: {
			type: String,
			default: 'activity'
		},
		breadcrumbs: {
			type: Boolean,
			default: false
		},
		search: {
			type: Boolean,
			default: false
		},
		pageTitle: {
			type: String,
			default: 'Default page title'
		},
		pageSubtitle: {
			type: String,
			default: 'Default page subtitle'
		},
		instanceClass : {
			type: String,
		},
		isSearchHeader: {
			type: Boolean,
			default: false,
			required: false
		}
	}
}
</script>